import { render } from "./CardItem.vue?vue&type=template&id=06d5c7b3&scoped=true&ts=true"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=06d5c7b3&scoped=true&lang=css"

import exportComponent from "D:\\onepack\\hotaru_theme-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d5c7b3"]])

export default __exports__